import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import utilsUsers from "../Connections/_Utils/utilsUsers";
import {
    AddCircleOutline, AlignHorizontalLeftRounded, ArrowCircleRightSharp,
    ArrowCircleUp, ContactlessOutlined, HighlightOff, RemoveCircleOutline
} from "@mui/icons-material";

import styles from './UserAdresses.module.css';

import pageStylePops from './pageStylePops.module.css';


import utilsOrders from "../Connections/_Utils/utilsOrders";

import Scroll from 'react-scroll';

import { UserContext } from "../Contexts/User_Context";
import { Checkbox } from "@mui/material";
import { MasterContext } from "../Contexts/Master_Context";
import { MobiOrNotContext } from "../Contexts/MobiOrNot_Context";
// import { TheOrderContext } from "../Contexts/TheOrder_Context";

var scroller = Scroll.scroller;

const UserAdresses = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);

    const [userAddressList, setUserAddressList] = useState([]);
    const [allAds, setAllAds] = useState([]);
    const [thePopUp, setThePopUp] = useState("");

    const [theErrors, setTheErrors] = useState("");
    const [errorsTxts, setErrorsTxts] = useState("");
    const [takeAway, setTakeAway] = useState(false);

    const [street, setStreet] = useState("");
    const [addressId, setAddressId] = useState("");
    const [num, setNum] = useState("");
    const [appartment, setAppartment] = useState("");
    const [ent, setEnt] = useState("");
    const [city, setCity] = useState("");
    const [flor, setFlor] = useState("");

    const [remarks, setRemarks] = useState("");

    const [showAddNew, setShowAddNew] = useState(false);

    const [theSele, setTheSele] = useState("");

    const deliveryCitys = master.cityesToDeliver || ["אשדוד"];

    const inOrder = props.inOrder;

    let theSelectdAdd = "";
    let popTiming = 0;


    const navigate = useNavigate();

    useEffect(() => {
        getAllAdresses();
    }, [])


    const getAllAdresses = async () => {
        let userAdds = await utilsUsers.getAdresses(user._id);

        setUserAddressList(userAdds)

        setShowAddNew(userAdds.length <= 0)
        if (inOrder.OrderType === 'Take') {
            setTakeAway(true)
        }
        else {
            if (inOrder?.deliveryAddress && userAdds.length > 0) {

                let addindex = userAdds.findIndex(addrs => addrs._id === inOrder.deliveryAddress._id);

                theSelectdAdd = userAdds[addindex];

                setTheSele(theSelectdAdd);
            }
        }
        setAddrs(userAdds);


    }

    const removeAddress = async (addsId) => {

        let userAdds = await utilsUsers.removeAddress(user._id, { addToRemove: addsId });
        let tempoSle = userAdds.findIndex((add) => add._id == addsId);
        setTheSele((tempoSle != -1) ? userAdds[tempoSle] : "");
        setAddrs(userAdds);

        setUserAddressList(userAdds)

    }


    const setTheSelectedAdd = (eCheck, addrsID, userAdds) => {
        theSelectdAdd = (eCheck) ? userAdds.find(ad => ad._id === addrsID) : "";
        setTheSele(theSelectdAdd);
        setAddrs(userAdds)
        setTakeAway(false)

    }

    //בדוק שכל התאים של הכתובת תקינים, 
    //או שיוצר הערות או שולח לפונקציה הוספת כתובת 
    const saveAddress = () => {
        setTheErrors("")
        setErrorsTxts("")

        let stopMe = false;
        let thEr = "";
        let errs = [];
        if (street.trim().length <= 1) {
            thEr = "street";
        }
        if (num.trim().length <= 0) {
            thEr += ",num";
        }
        if (city.trim() <= 0 || city.trim() === "בחר עיר") {
            thEr += ",city";
        }
        if (thEr != "") {
            setTheErrors(thEr)
            setErrorsTxts(errs)
        }
        else {

            addNewAddress();
            setErrorsTxts("")

        }
    }

    //הוספת כתובת בדאטה בייס
    const addNewAddress = async () => {

        let citybk = (city != null) ? city : "אשדוד";

        let addAdres = await utilsUsers.addNewAddress(user._id, { street, num, appartment, ent, flor, city: citybk, remarks });
        setUserAddressList(addAdres)

        theSelectdAdd = addAdres[addAdres.length - 1];
        setTheSele(theSelectdAdd);
        setAddrs(addAdres);
        //מאפס את כל תיבות הטקסט לאחר הוספת הכתובת
        setStreet("");
        setNum("");
        setAppartment("");
        setEnt("");
        setCity("");
        setFlor("");
        setRemarks("");
        setTheErrors("");

        //מעלים את הוספת כתובת
        setShowAddNew(false)
    }


    const setTheTakeAway = () => {
        setTakeAway(!takeAway);
        setTheSele("");
        setAddrs(userAddressList)
    }


    let TakeAwayBlock =
        <div key={"takeiT"} >
            <div className="firstDelTd pointing flexIt fullRow" >
                {/* First column (Checkbox) */}
                <div className="column" style={{ flex: "0 0 10%" }}>
                    <Checkbox
                        checked={takeAway}
                        style={{ color: "var(--blueWeb)" }}
                        onChange={(e) => setTheTakeAway()}
                    />
                </div>

                {/* Second column (Address Details) */}
                <div className={`${currnetStyle.addressDelTd} column`}
                    onClick={() => setTheTakeAway()}
                    style={{ flex: "0 0 75%", paddingTop: "11px" }}>
                    {`איסוף עצמי`}
                </div>

            </div>
            <div className={"claerlineSpacer fullRow"}></div>
            <div className={"dottedLineSpacer fullRow"}></div>
            <div className={"claerlineSpacer fullRow"}></div>
        </div>



    //מציג את כל הכתובות הקיימות ומסמן את הנבחרת
    const setAddrs = (userAdds) => {
        let addresses = userAdds.map((addrs, index) => {
            let chkd = false;

            if (theSelectdAdd) {
                if (addrs._id == theSelectdAdd._id) {
                    chkd = true;
                }
            }

            return (
                <div key={index} >
                    <div className="firstDelTd pointing flexIt fullRow" >
                        {/* First column (Checkbox) */}
                        <div className="column" style={{ flex: "0 0 10%" }}>
                            <Checkbox
                                checked={chkd}
                                style={{ color: "var(--blueWeb)" }}
                                onChange={(e) => setTheSelectedAdd(e.target.checked, addrs._id, userAdds)}
                            />
                        </div>

                        {/* Second column (Address Details) */}
                        <div className={`${currnetStyle.addressDelTd} column`}
                            onClick={() => setTheSelectedAdd(!chkd, addrs._id, userAdds)}
                            style={{ flex: "0 0 75%" }}>
                            {`${addrs.street} ${addrs.num}`}
                            <br />
                            {(addrs.appartment ? `דירה: ${addrs.appartment} ` : "")}
                            {(addrs.ent ? `כניסה: ${addrs.ent} ` : "")}
                            {(addrs.flor && addrs.num ? `קומה: ${addrs.flor} ` : "")}
                            {(addrs.city ? ` ${addrs.city}` : "לא ידוע")}
                            <br />
                            {(addrs.remarks ? `הערות לשליח: ${addrs.remarks}` : "")}
                        </div>

                        {/* Third column (Remove Icon) */}
                        <div className="column flex-Center centerText " style={{ flex: "0 0 10%" }}>
                            <RemoveCircleOutline
                                onClick={() => removeAddress(addrs._id)}
                                style={{ color: "var(--blueWeb)" }}
                            />
                        </div>

                    </div>
                    <div className={"claerlineSpacer fullRow"}></div>
                    <div className={"dottedLineSpacer fullRow"}></div>
                    <div className={"claerlineSpacer fullRow"}></div>
                </div>


            )
        })


        setAllAds(addresses);

    }

    //אם הכל תקין בבחירת כתובת, מחזיר את האיידי של הכתובת הנבחרת
    const finishOrder = async () => {

        if (theSele === "" || theSele === null) {
            if (!takeAway) {
                setTheErrors("selectAdd");
                setErrorsTxts("יש לבחור איסוף או כתובת למשלוח")
            }
            else {
                props.setTheAddress(null);
            }
        }
        else {
            theSele.addressId = theSele._id
            props.setTheAddress(theSele);

        }
    }

    const goToBack = () => {
        navigate.goBack();

    }


    const showhideAdress = () => {

        setShowAddNew(!showAddNew)

        if (!showAddNew) {
            setTimeout(function () {
                scroller.scrollTo(`newAddress`, { smooth: true, offset: -120, duration: 1000 });
            }, 20)
        }
    }

    return (
        <div id={props.addId} className={"loginPage"}>
            {/* {!props.noHead ? <div className={"headOnFixC SecondFont bold big"}>
                כתובת למשלוח
                <div className={`backSd`}>
                    <ArrowCircleRightSharp onClick={() => goToBack()} />
                </div>
                <br />
            </div>
                : ""} */}

            <div className={`${currnetStyle.firstMastSec}`}>

                <div className={"fullRow spaceMargeTop_10"}>
                    {TakeAwayBlock}
                    {allAds}
                </div>
                <br />
                {allAds.length > 0 &&
                    <div className="fullWidth spaceButtomBig" style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            className="bold big addressAddBtn"
                            style={{
                                flex: '0 0 10%',
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}
                            onClick={() => showhideAdress()}
                        >
                            {showAddNew ? (
                                <RemoveCircleOutline
                                    className="plusOnAddRes"
                                    style={{ color: 'var(--blueWeb)', padding: '5px' }}
                                />
                            ) : (
                                <AddCircleOutline
                                    className="plusOnAddRes"
                                    style={{ color: 'var(--blueWeb)', padding: '5px' }}
                                />
                            )}
                        </div>
                        <div
                            style={{ flex: '0 0 87%', verticalAlign: 'middle', fontSize: 'large', cursor: 'pointer' }}
                            onClick={() => showhideAdress()}
                        >
                            כתובת אחרת
                        </div>
                    </div>

                }

                <div className={"fullRow"}>
                    {(showAddNew) ?
                        <div className={`${currnetStyle.addAddressBlock}`} id="newAddress">
                            <div className={`${currnetStyle.usrDetLong} details`} >
                                <input type={"text"} className={`${currnetStyle.connInput} ${(theErrors.includes("street") ? "errorInput" : "")}`} value={street} placeholder={"רחוב"} onChange={(e) => setStreet(e.target.value)} />
                            </div>
                            <div className={"fullRow flexIt"}>
                                <div className={`${currnetStyle.usrDetSmall} flex-1 details`} >
                                    <input type={"text"} className={`${currnetStyle.connInput} ${(theErrors.includes("num") ? "errorInput" : "")}`} value={num} placeholder={"בית"} onChange={(e) => setNum(e.target.value)} />
                                </div>
                                <div className={`${currnetStyle.usrDetSmall} flex-1 details`} >
                                    <input type={"text"} className={`${currnetStyle.connInput} ${(theErrors.includes("apprtment") ? "errorInput" : "")}`} value={appartment} placeholder={"דירה"} onChange={(e) => setAppartment(e.target.value)} />
                                </div>
                                <div className={`${currnetStyle.usrDetSmall} flex-1 details`} >
                                    <input type={"text"} className={`${currnetStyle.connInput} `} value={ent} placeholder={"כניסה"} onChange={(e) => setEnt(e.target.value)} />
                                </div>
                                <div className={`${currnetStyle.usrDetSmall} flex-1 details`} >
                                    <input type={"text"} className={`${currnetStyle.connInput} `} value={flor} placeholder={"קומה"} onChange={(e) => setFlor(e.target.value)} />
                                </div>
                            </div>

                            <div className={`usrDet details`} >

                                <select
                                    className={`${currnetStyle.connSelection} ${(theErrors.includes("city") ? "errorInput" : "")}`}
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                >
                                    <option key={-1} className="customMenuItem" value="">
                                        בחר עיר
                                    </option>
                                    {deliveryCitys.map((item, index) => (
                                        <option
                                            key={index}
                                            className="customMenuItem"
                                            value={item.cityName} // וודא שהערך תואם למה שאתה שומר ב-city
                                        >
                                            {item.cityName}
                                        </option>
                                    ))}
                                </select>


                            </div>


                            <div className={`${currnetStyle.usrDetLong} details`} >
                                <textarea className={`${currnetStyle.txtArea}`} value={remarks} placeholder={"הערות לשליח"} onChange={(e) => setRemarks(e.target.value)}></textarea>
                            </div>
                            <div className={"details fullWidth"}>
                                <div className={`${currnetStyle.goBtn} pointing bold`} onClick={() => saveAddress()}>שמור כתובת</div>
                            </div>

                        </div>
                        :
                        <div className={`${currnetStyle.ContinueToPayLine} fullRow`} onClick={() => { }}>
                            <div className={`${currnetStyle.goBtn} pointing bold`} onClick={() => finishOrder()}>המשך</div>
                        </div>

                    }
                    {
                        (theErrors !== "") &&
                        <div className={"fullRow errorLine bold"}>
                            {
                                (!theErrors.includes("address") &&
                                    !theErrors.includes("num") &&
                                    errorsTxts !== "") ?
                                    <p className={"bold noMargin centerText"}>{errorsTxts}</p> :
                                    <p className={"bold noMargin centerText"}>{"התאים המסומנים הינם חובה"}</p>

                            }
                        </div>
                    }
                </div>



                {thePopUp}
            </div>

        </div>


    )

}

export default UserAdresses